import { Controller as BaseController } from 'stimulus'

export class Controller extends BaseController {
  static targets = ['trigger', 'list']

  /**
     * Close the menu when someone clicks on a part of the document
     * that isn't the menu trigger, list, or list item.
     * @param {MouseEvent} event
     */
  handleOutsideClick(event) {
    const clickedOutside = !this.triggerTarget.contains(event.target) && !this.listTarget.contains(event.target)

    if (clickedOutside) {
      this.closeMenu()
    }
  }

  closeMenu() {
    this.element['class-toggler'].toggleAllBackToOriginal()
  }
}
